import qs from 'qs';

export const query = qs.parse(window.location.search.slice(1));

export const formatPhone = phone =>
  phone && phone.replace(/\B(?=(?:\d{4})+$)/g, '-');
